class HeaderTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const duration =
      this.querySelector('.hd-Ticker_Scroller').scrollWidth / 100

    this.style.setProperty('--Ticker_Speed', duration)
  }
}

if (!customElements.get('header-ticker')) {
  customElements.define('header-ticker', HeaderTicker)
}
